import actions from './constants';

export const fetchRequestWorkspaces = (category, code, location) => ({
  type: actions.FETCH_REQUEST_WORKSPACES,
  category,
  code,
  location,
});

export const toggleRequestWorkspaceSelected = (category, code, uuid) => ({
  type: actions.TOGGLE_REQUEST_WORKSPACE_SELECTED,
  category,
  code,
  uuid,
});

export const showRequestWorkspaces = (category, code, results) => ({
  type: actions.SHOW_REQUEST_WORKSPACES,
  category,
  code,
  results,
});

export const showRequestWorkspacesError = (category, code, error) => ({
  type: actions.SHOW_REQUEST_WORKSPACES_ERROR,
  category,
  code,
  error,
});

export const toggleWorkspaceRequest = (category, code) => ({
  type: actions.TOGGLE_WORKSPACE_REQUEST,
  category,
  code,
});

export const fetchRequestWorkspace = (code) => ({
  type: actions.FETCH_REQUEST_WORKSPACE,
  code,
});

export const showRequestWorkspace = (code, result) => ({
  type: actions.SHOW_REQUEST_WORKSPACE,
  code,
  result,
});

export const showRequestWorkspaceError = (code, error) => ({
  type: actions.SHOW_REQUEST_WORKSPACE_ERROR,
  code,
  error,
});

export const showFormForWorkspaceRequest = (code, result) => ({
  type: actions.SHOW_FORM_FOR_WORKSPACE_REQUEST,
  code,
  result,
});

export const showWorkspaceFormForRequest = (category, code, result, workflow) => ({
  type: actions.SHOW_WORKSPACE_FORM_FOR_REQUEST,
  category,
  code,
  result,
  workflow,
});

export const fetchRequestLocations = (category, code) => ({
  type: actions.FETCH_REQUEST_LOCATIONS,
  category,
  code,
});

export const showRequestLocations = (category, code, results) => ({
  type: actions.SHOW_REQUEST_LOCATIONS,
  category,
  code,
  results,
});

export const showRequestLocationsError = (category, code, error) => ({
  type: actions.SHOW_REQUEST_LOCATIONS_ERROR,
  category,
  code,
  error,
});
